import { render } from "./NotFound.vue?vue&type=template&id=8695f73a"
const script = {}

import exportComponent from "E:\\Projects\\Volcor\\GitHubVolcor\\Portal.Volcor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__